import React from 'react';

import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import OutlinedInput, {OutlinedInputProps} from '@material-ui/core/OutlinedInput';

interface LabelInputProps extends OutlinedInputProps {
  label?: React.ReactNode;
  labelPlacement?: 'end' | 'start' | 'top' | 'bottom';
}

export const LabelInput: React.FC<LabelInputProps> = ({
  label,
  labelPlacement = 'start',
  ...props
}) => {
  return (
    <FormControl fullWidth={typeof props.fullWidth !== 'undefined' ? props.fullWidth : true}>
      <FormControlLabel
        name={props.name}
        control={<OutlinedInput fullWidth {...props} />}
        label={label}
        labelPlacement={labelPlacement}
      />
    </FormControl>
  );
};
